<template>
  <section class="counter">
    <label :for="tid">{{ title }}</label>
    <div>
      <button @click="valueDown"><span class="chevron left"></span></button>

      <input :id="tid" type="text" v-model="qt" @blur="checkQt" />
      <button class="btn-up" @click="valueUp">
        <span class="chevron right"></span>
      </button>
    </div>
  </section>
</template>

<script>
export default {
  props: ['title', 'count'],
  data() {
    return {
      tid: '',
      qt: parseInt(this.count)
    }
  },
  methods: {
    valueDown() {
      this.qt = parseInt(this.qt)

      if (isNaN(this.qt)) {
        this.qt = 1
      } else if (this.qt > 0) {
        this.qt -= 1
      }
      if (this.qt < 1) {
        this.qt = 1
      }

      this.$emit('set-count', this.qt)
    },
    valueUp() {
      this.qt = parseInt(this.qt)

      if (isNaN(this.qt)) {
        this.qt = 1
      } else {
        this.qt += 1
      }
      if (this.qt < 1) {
        this.qt = 1
      }
      this.$emit('set-count', this.qt)
    },
    checkQt() {
      if (isNaN(this.qt)) {
        this.qt = 1
      }
      if (this.qt < 1) {
        this.qt = 1
      }
      this.$emit('set-count', this.qt)
    }
  },
  mounted() {
    this.tid = this._uid
  }
}
</script>

<style lang="scss" scoped>
.counter {
  display: flex;
  align-items: center;
  padding: 10px 0;
}
input {
  width: 31px;
  height: 31px;
  border: 1px solid #979797;
  border-radius: 16px;
  text-align: center;
  font-weight: 500;
  margin: 0;
  -webkit-appearance: none;
}

.chevron {
  color: var(--sub-color);
}

.btn-up {
  margin-left: 1px;
}

label {
  margin-right: 10px;
}
</style>
